/** Base for every error this codec raises. Callers can catch this one type. */
export class FitError extends Error {
  constructor(message: string) {
    super(message)
    this.name = new.target.name
  }
}

/** The input is not a FIT file, or is structurally broken. */
export class FitDecodeError extends FitError {}

/** A value does not fit the base type it must be written into. Last line of defence. */
export class FieldRangeError extends FitError {
  constructor(
    readonly globalMessageNumber: number,
    readonly fieldKey: string,
    readonly value: number,
    detail: string,
  ) {
    super(`global ${globalMessageNumber} field ${fieldKey}: value ${value} ${detail}`)
  }
}

/** A field we need to write is absent from the message definition in force. */
export class FieldNotInDefinitionError extends FitError {
  constructor(
    readonly globalMessageNumber: number,
    readonly fieldDefNum: number,
  ) {
    super(`global ${globalMessageNumber} has no field ${fieldDefNum} in its definition`)
  }
}

/**
 * We can pass compressed-timestamp records through untouched, but rewriting one
 * correctly requires reproducing the rolling 5-bit timestamp state. Refuse instead.
 */
export class UnsupportedCompressedTimestampError extends FitError {
  constructor(globalMessageNumber: number) {
    super(
      `global ${globalMessageNumber} uses a compressed-timestamp header; ` +
        `this file cannot be edited (reading it is fine)`,
    )
  }
}
